import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from 'react-router-dom'
import { isAllow } from 'Modules/catalogs/walletExpense'
import Show from 'Components/common/Show'

import catalogoProveedorImg from '../../styles/images/Catalogo-Proveedores.png';
import catalogoColaboradorImg from '../../styles/images/Catalogo-Colaboradores.png';
import catalogoMonederoImg from '../../styles/images/Catalogo-Monedero.png';
import catalogoGasolinaImg from '../../styles/images/Catalogo-Gasolina.png';
import catalogoClientesImg from '../../styles/images/Catalogo-Clientes.png';
import catalogoPrestamistasImg from '../../styles/images/Catalogo-Prestamistas.png';
import catalogoProductosServiciosImg from '../../styles/images/Catalogo-Productos.png';

const hasProvidersPermission = (permissions) => {
  return ['pagoAproveedores', 'reciboHonorario', 'reembolsos']
    .some(permission => +permissions[permission] === 1)
}

const hasCustomersPermission = (permissions) => {
  return +permissions.facturacion === 1
}

const hasEmployeesPermission = (permissions) => {
  return ['reembolsos', 'convenioIntegrados']
    .some(permission => +permissions[permission] === 1)
}

const hasGasolinaPermission = (permissions) => {
  return +permissions.monederosGasolina === 1
}

const hasLendersPermission = (permissions) => {
  return +permissions.prestamos === 1
}

export class Catalogs extends Component {
  componentDidMount() {
    this.props.isAllow()
  }

  render() {
    const { walletExpenseAllow } = this.props
    return (
      <section className="info-tiles multiline">
        <div className="tile is-ancestor has-text-centered">
          <Show canShow={hasProvidersPermission(this.props.permissions)}>   
          <div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/proveedores">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoProveedorImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Proveedores</p>
            </Link>
          </div>
          </Show>
          <Show canShow={hasEmployeesPermission(this.props.permissions)}>
          <div className="tile is-parent">
            <Link className="tile is-child box cat-prov" to="/catalogos/colaboradores">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoColaboradorImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Colaboradores</p>
            </Link>
          </div>
          </Show>
          {walletExpenseAllow &&  (<div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/monederos-gastos">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoMonederoImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Monederos de Gastos</p>
            </Link>
          </div>)}
          <Show canShow={hasGasolinaPermission(this.props.permissions)}>
          <div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/monederos-gasolina">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoGasolinaImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Monederos de Gasolina</p>
            </Link>
          </div>
          </Show>
          </div>
        <div className="tile is-ancestor has-text-centered">
          <Show canShow={hasCustomersPermission(this.props.permissions)}>
          <div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/clientes">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoClientesImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Clientes</p>
            </Link>
          </div>
          </Show>
          <Show canShow={hasLendersPermission(this.props.permissions)}>
          <div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/prestamistas">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoPrestamistasImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Prestamistas</p>
            </Link>
          </div>
          </Show>
        
          <div className="tile is-parent">
            <Link className="tile is-child box" to="/catalogos/productos-servicios">
              <p className="title has-text-grey-dark">
                <img className="icons" src={catalogoProductosServiciosImg} alt="catalogo de proveedores" />
              </p>
              <p className="subtitle">Productos y servicios</p>
            </Link>
          </div>
          <div className="tile is-parent">
          </div>
        </div>
      </section>
    )
  }
}

const mapStateToProps = ({catalogs, principal }) => ({
  walletExpenseAllow: catalogs.walletExpense.isAllow,
  permissions: principal.inventoryPermission,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  isAllow,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Catalogs)
